// fetchThumbnailsWithCache.js
import axiosInstance from "utils/axiosInstance";
import {
  saveThumbnailToIndexedDB,
  getThumbnailFromIndexedDB,
  deleteOldThumbnails
} from "./indexedDBThumbnails";

// Default fallback order (highest quality -> lowest)
const fallbackSizes = ["sizeOriginal", "sizeMedium", "sizeSmall"];

// type: 'infoCollection' | 'infoTopic'
// preferredSize: optional, default is 'sizeSmall'
export async function fetchThumbnailsWithCache(
  entries,
  type,
  preferredSize = "sizeSmall",
  onResult, // required: callback for each thumbnail
  onDone,    // optional: callback after all are processed
  forceRefresh = false
) {

  const sizeOrder = getSizeFallbackOrder(preferredSize);

  let completedCount = 0;

  entries.forEach(async ({ _id: id, updatedAt }) => {
    for (let size of sizeOrder) {
      const timestamp = forceRefresh ? new Date().getTime() : new Date(updatedAt).getTime();
      const cacheKey = `${id}_${timestamp}_${size}`;
      console.log('forceRefresh:', forceRefresh);
      //const cachedBlob = forceRefresh ? null : await getThumbnailFromIndexedDB(cacheKey);
      const cachedBlob = null;

      if (cachedBlob) {
        console.log('cacheKey found:', cacheKey.slice(-35));
        console.log('HERE calculating size1');
        onResult({ id, url: URL.createObjectURL(cachedBlob), blob: cachedBlob });
        completedCount++;
        if (completedCount === entries.length && onDone) onDone();
        return;
      }

      if(id){
        console.log('cacheKey not found:', cacheKey.slice(-35));
        let endpoint = size === "sizeOriginal"
          ? `/knovia/${type}/${id}/viewThumbnail`
          : `/knovia/${type}/${id}/viewThumbnail/${size}`;

        try {
          const res = await axiosInstance.get(endpoint, { responseType: "blob" });
          if(res.status === 204 || res.data.size === 0) {
            console.log('No image found for cacheKey:', cacheKey);
            break; // move to next size or finish
          }

          const blob = new Blob([res.data], { type: res.headers["content-type"] });
          console.log('saving cacheKey:', cacheKey);
          await saveThumbnailToIndexedDB(cacheKey, blob);
          await deleteOldThumbnails(id, timestamp, size);

          console.log('HERE calculating size2');
          onResult({ id, url: URL.createObjectURL(blob), blob: blob });

          completedCount++;
          if (completedCount === entries.length && onDone) onDone();
          return;
        } catch (err) {
          console.warn(`Failed to fetch ${type} ${size} thumbnail for ID: ${id}`);
          // Continue trying next size
        }
      } else {
        console.warn(`Invalid ID: ${id}`);
      }
    
    }

    // All sizes failed
    onResult({ id, url: null, blob: null });
    completedCount++;
    if (completedCount === entries.length && onDone) onDone();
  });
}

function getSizeFallbackOrder(preferred) {
  const index = fallbackSizes.indexOf(preferred);
  return index !== -1 ? fallbackSizes.slice(index) : [preferred];
}


